import React, { useContext } from 'react'
import ApolloContext from '../../../../../context/ApolloContext'
import { Link } from 'gatsby'
import './style.scss'


function CustomBlock({ fields: field }) {
	const apollo = useContext(ApolloContext)
	const degreesFiltered = field ? apollo.data?.degrees?.nodes.filter(node => node.slug === field[0]) : null

	const sortedNodes = degreesFiltered?.[0]?.academics?.nodes
		? [...degreesFiltered[0].academics.nodes].sort((a, b) => {
				const titleA = a.title?.toLowerCase() || '';
				const titleB = b.title?.toLowerCase() || '';
				if (titleA < titleB) return -1;
				if (titleA > titleB) return 1;
				return 0;
		  })
		: [];

	const posts = sortedNodes?.map((node, i) => {
		return (
			<Link key={i} to={node.uri} className="single-post">
				<article className="flex column">
					<div className="img-container">
						<img srcSet={node.featuredImage?.node.srcSet} alt='' />
					</div>
					<div className="content">
						<h2 className='h6'>
							{node.title}
						</h2>
						<p className="link">
							LEARN MORE
						</p>
					</div>
				</article>
			</Link>
		)
	})



	return (
		<div className="grid-12 ">
			{apollo.isLoading ?
				<div className="span-12 loading">loading...</div>
				:
				<div className="span-12 flex wrap c5">
					{posts}
				</div>
			}
		</div>
	)
}

export default CustomBlock